module.exports = __webpack_public_path__ + "media/gcc_introductions/bg_infinity-52705307.svg";